import { render } from "./KillsBoard.vue?vue&type=template&id=30cb6492"
import script from "./KillsBoard.vue?vue&type=script&lang=js"
export * from "./KillsBoard.vue?vue&type=script&lang=js"

import "./KillsBoard.vue?vue&type=style&index=0&id=30cb6492&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__